export default __webpack_public_path__ + "static/media/service-5-outdoor.c5d8b8cf.png";